import React, { useState } from 'react';
import { useAuth }    from '../context/AuthContext';
import { useCompany } from '../context/CompanyContext';
import './LoginPage.css';

export default function LoginPage() {
  const { login }                         = useAuth();
  const { companyDetails }                = useCompany();
  const [form, setForm]                   = useState({ username: '', password: '' });
  const [error, setError]                 = useState('');
  const [loading, setLoading]             = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // company_id comes from CompanyContext (stored in localStorage by CompanyProvider)
      await login(form.username, form.password, companyDetails.companyId);
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-grid" aria-hidden />
      <div className="login-bg-glow" aria-hidden />

      <div className="login-card fade-up">
        {/* Show logo only when a URL is available — no fallback placeholder */}
        {companyDetails.logo_url && (
          <div className="login-logo">
            <img
              src={companyDetails.logo_url}
              alt={companyDetails.company_name || 'Company logo'}
              className="login-logo-img"
            />
          </div>
        )}

        <div className="login-divider" />

        {error && (
          <div className="login-error fade-up">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="username">Username</label>
            <input
              id="username"
              name="username"
              className="input-field"
              placeholder="Enter your username"
              value={form.username}
              onChange={handleChange}
              autoComplete="username"
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              className="input-field"
              placeholder="Enter your password"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-full" disabled={loading}>
            {loading ? (
              <>
                <span className="btn-spinner" />
                Signing in…
              </>
            ) : 'Sign In'}
          </button>
        </form>

        <p className="login-footer">
          Contact your administrator if you don't have credentials.
        </p>
      </div>
    </div>
  );
}
